import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStoreActions, useStoreState } from '../../../../../models/hooks';
import { MultiSelect } from './MultiSelect';

function JobSelectComponent() {
  const { t } = useTranslation('moniterByRecruiters');
  const accountId = useStoreState((s) => s.app.user?.account);

  const { positionFilters } = useStoreState((state) => state.moniterByRecruiters);
  const { fetchJobs, setPositionFilter } = useStoreActions((state) => state.moniterByRecruiters);
  const [isLoading, setIsLoading] = React.useState(false);
  const [positions, setPositions] = React.useState<Record<string, 'open' | 'closed' | 'archived'>>();

  React.useEffect(() => {
    /* istanbul ignore else */
    if (accountId) {
      setIsLoading(true);
      fetchJobs({ accountId })
        .then((res) => {
          setPositions(res ?? /* istanbul ignore next */ {});
        })
        .catch(() => {
          // Handle error silently
        })
        .finally(() => {
          setIsLoading(false);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountId]);

  const filteredKeys = React.useMemo(() => {
    if (!positions) return [];

    return Object.keys(positions).filter(
      /* istanbul ignore next */ (key) => positionFilters?.positionStatus?.includes(positions[key]),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [positions, positionFilters?.positionStatus]);

  React.useEffect(() => {
    setPositionFilter({ key: 'jobCustomNames', value: filteredKeys });
  }, [filteredKeys, setPositionFilter]);

  const options = React.useMemo(() => {
    return filteredKeys.map(
      /* istanbul ignore next */ (job) => ({
        value: job,
        label: job,
      }),
    );
  }, [filteredKeys]);

  return (
    <MultiSelect
      options={options}
      selectedValues={positionFilters.jobCustomNames ?? /* istanbul ignore next */ []}
      onChange={(vals, selectAll) => {
        setPositionFilter({ key: 'jobCustomNames', value: vals });
        setPositionFilter({ key: 'isAllJobSelected', value: selectAll });
      }}
      selectAll={positionFilters.isAllJobSelected}
      label={t('filter.jobs.label')}
      allSelectText={t('filter.jobs.all')}
      placeholder={t('filter.jobs.search')}
      isLoading={isLoading}
      height={400}
      itemHeight={40}
    />
  );
}

export const JobSelect = React.memo(JobSelectComponent);
